import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgotPassword2Component } from './forgot/forgot-password-2.component';
import { ForgotPassword1Component } from './forgot/forgot-password-1.component';
import { RegistrationConfirmationComponent } from './confirm/confirm-registration.component';
import { AwsUtil } from './aws.service';
import { LogoutComponent } from './logout/logout.component';
import { RegisterComponent } from './register/registration.component';
import { NewPasswordComponent } from './newpassword/newpassword.component';
import { CognitoUtil } from './cognito.service';
import { UserLoginService } from './user-login.service';
import { UserRegistrationService } from './user-registration.service';
import { LoginComponent } from './login/login.component';
import { UIModule } from '../common/ui.module';
import { JWTService } from './jwt.service';

// import { AmplifyAngularModule, AmplifyService } from 'aws-amplify-angular';

@NgModule({
    imports: [
        CommonModule,
        UIModule,
        // AmplifyAngularModule,
    ],
    declarations: [
        LoginComponent,
        LogoutComponent,
        NewPasswordComponent,
        RegisterComponent,
        RegistrationConfirmationComponent,
        ForgotPassword1Component,
        ForgotPassword2Component,
    ],
    providers: [
        CognitoUtil,
        AwsUtil,
        UserLoginService,
        UserRegistrationService,
        JWTService,
        // AmplifyService,
    ],
    exports: [
    ]
})
export class AuthenticationModule {

}
